// https://stackoverflow.com/a/34064434
export function htmlDecode(str){
    var doc = new DOMParser().parseFromString(str, "text/html");
    return doc.documentElement.textContent;
}

/**
 * 
 * @param {string} tagname 
 * @param  {...string} classes 
 * @returns HTMLElementTagNameMap
 */
export function createElementWithInitalClasses(tagname, ...classes){
    const d = document.createElement(tagname);
    if (classes.length > 0) d.classList.add(...classes);
    return d;
}

/**
 * 
 * @param {HTMLElement} element 
 * @param {Object<string, any>} attributes 
 */
export function setMultipleAttributes(element, attributes){
    if(typeof(attributes) !== "object") return;
    
    for (const key in attributes) {
        element.setAttribute(key, attributes[key]);
    }
}